/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react';
import styles from './WatchListStyles';
import axios from 'axios';
import { firestore } from '../../fire';
import moment from 'moment';
import { Grid } from '@material-ui/core';
import Tickers from './stockTicker.json';
import { makeStyles } from '@material-ui/core/styles';
import WatchListDelete from '../../components/Modals/WatchListDelte';
import Snackbar from '@material-ui/core/Snackbar';
import { Alert } from '@material-ui/lab';
import WatchListDeleteFavouriteTicker from '../../components/Modals/WatchListDeleteFavouriteTicker';
import ToolTipModal from '../../components/Modals/ToolTip Modal';
import { calculateOption } from './functions';
import WatchListRightSide from './components/WatchListrightSide';
import WatchListSearch from './components/WatchListSearch';
import { useSelector } from 'react-redux';
import { BaseURL } from '../../constants';

export const useStyles = makeStyles({
  root: {
    color: 'darkgrey',
    padding: 0,
    marginTop: 12,
    marginLeft: 8,
    width: 16,
    height: 0,
  },
  MuiSvgIcon: {
    root: {
      height: '0.25rem',
    },
  },
});

const WatchList = ({ loginCheck }) => {
  const [isMobile, setisMobile] = useState(false);
  const [myFav, setmyFav] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(false);
  const [filteredTickers, setFilteredTickers] = useState([]);
  const [favTicker, setfavTicker] = useState([]);
  const [deleteCheck, setdeleteCheck] = useState(false);
  const [watchlistDeleteModal, setwatchlistDeleteModal] = useState(false);
  const [watchlistFavDeleteModal, setwatchlistFavDeleteModal] = useState(false);
  const [watchlistFavDeleteData, setwatchlistFavDeleteData] = useState([]);
  const [watchListDeleteData, setwatchListDeleteData] = useState([]);
  const [snakMessage, setsnakMessage] = useState('');
  const [snakOpen, setsnakOpen] = useState(false);
  const [favLoading, setFavLoading] = useState(false);

  const [snaktype, setsnaktype] = useState('success');

  const [zoomPercent, setzoomPercent] = useState('100%');

  const appState = useSelector((state) => state.appReducer);
  const { accessLevel, userData } = appState;

  useEffect(() => loginCheck(), []);

  const isMobileFunction = () => {
    let check = window.innerWidth < 1280 ? true : false;
    setisMobile(check);
  };

  const setFilteredTickersFunction = () => {
    let tickers = Tickers.map((ticker, index) => {
      return { label: ticker.usymbol, value: index };
    });
    setFilteredTickers(tickers);
  };
  useEffect(() => {
    setFilteredTickersFunction();
  }, [Tickers]);

  const setFavFunctionNew = async () => {
    const user = userData.sub;
    const concatedUser = `felix${user}`;
    setLoading(true);
    if (userData && Object.keys(userData).length) {
      const snapShot = await firestore
        .collection('favourite')
        .doc(`${concatedUser}`)
        .collection('data')
        .get();
      try {
        let dataArray = await Promise.all(
          snapShot.docs.map(async (doc) => {
            const data = doc.data();
            const id = doc.id;
            data.id = id;
            data.value = false;
            const newDate = moment().format('YYYY-MM-DD');
            try {
              let [firstApiData, OptionData] = await Promise.all([
                axios.get(
                  `${BaseURL}/api/get-ticker-details/${data.symbol}`
                ),
                axios.get('/api/favApi', {
                  baseURL: BaseURL,
                  params: {
                    symbol: data.symbol,
                    expiry: data.Expiry,
                    date: newDate,
                    put_call: data.PutCall,
                    strike: data.Strike,
                  },
                  headers: {
                    'Content-Type': 'application/json', // Add this line

                  },
                }),
              ]);

              data.secondstock = firstApiData.data[0].close
                ? firstApiData.data[0].close.toFixed(2)
                : '-';
              data.chgDollar = firstApiData.data[0].spot_chg
                ? firstApiData.data[0].spot_chg
                : '-';
              data.chgPercent = firstApiData.data[0].spot_chg_pct
                ? firstApiData.data[0].spot_chg_pct
                : '-';
              data.option =
                OptionData.data.length &&
                  moment(newDate, 'YYYY-MM-DD').isSameOrBefore(data.Expiry)
                  ? OptionData.data[0].theo_ask.toFixed(2)
                  : await calculateOption(
                    data.Expiry,
                    data.Strike,
                    data.PutCall,
                    data.symbol
                  );
              data.optionchgDollar = data.option
                ? data.option - data.Price
                : '-';
              data.optionchgPercent = data.option
                ? (data.option - data.Price) / data.Price
                : '-';
              data.expired = moment(newDate, 'YYYY-MM-DD').isAfter(data.Expiry)
                ? true
                : false;
              return data;
            } catch (error) {
              console.log('error', error);
              data.secondstock = undefined;
              data.chgDollar = undefined;
              data.chgPercent = undefined;
              data.option = '-';
              data.optionchgDollar = '-';
              data.optionchgPercent = '-';
              data.expired = moment(newDate, 'YYYY-MM-DD').isAfter(data.Expiry)
                ? true
                : false;

              return data;
            }
          })
        );
        setmyFav(dataArray);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const handleClickSnak = (snakMessage, snaktype) => {
    setsnaktype(snaktype);
    setsnakMessage(snakMessage);
    setwatchlistDeleteModal(false);
    setdeleteCheck(false);
    setsnakOpen(true);
    setFavFunctionNew();
  };

  const handleClickSnakFavTicker = (snakMessage, snaktype) => {
    setsnaktype(snaktype);
    setsnakMessage(snakMessage);
    setsnakOpen(true);
    setwatchlistFavDeleteModal(false);
    getFavouriteTickers();
  };

  const getFavouriteTickers = async () => {
    if (userData && Object.keys(userData).length) {
      setFavLoading(true);
      let favTicker = [];
      const SnapShot = await firestore
        .collection('FavouriteTickers')
        .doc(`felix${userData.sub}.bsk`)
        .collection('data')
        .get();
      SnapShot.docs.forEach((doc) => {
        doc.value = false;
        const tickerArray = {
          name: doc.id,
          value: false,
        };
        favTicker.push(tickerArray);
      });
      setfavTicker(favTicker);
      setFavLoading(false);
    }
  };

  const setMediaQuery = () => {
    if (window.innerWidth >= 1280 && window.innerWidth < 1366) {
      setzoomPercent('79%');
    } else if (window.innerWidth >= 1366 && window.innerWidth < 1440) {
      setzoomPercent('85%');
    } else if (window.innerWidth >= 1440 && window.innerWidth < 1500) {
      setzoomPercent('90%');
    } else if (window.innerWidth >= 1500 && window.innerWidth < 1600) {
      setzoomPercent('94%');
    }
  };
  useEffect(() => {
    if (window.innerWidth) {
      setMediaQuery();
      isMobileFunction();
    }
    if (!userData) {
      console.log('User Deta Exist')
      return
    }

    setFavFunctionNew();
    getFavouriteTickers();

  }, [userData]);

  let check = window.innerWidth > 2000;
  return (
    <div
      style={
        isMobile
          ? styles.containerMobile
          : {
            ...styles.container,
            margin: check ? 'auto' : '',
            width: check ? '1600px' : '',
          }
      }
    >
      <Grid container>
        <Snackbar
          open={snakOpen}
          color="green"
          ContentProps={{
            sx: {
              background: 'green',
            },
          }}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          autoHideDuration={5000}
          onClose={() => setsnakOpen(false)}
          message={snakMessage}
        >
          <Alert
            onClose={this.handleCloseSnak}
            severity={snaktype}
            sx={{ width: '100%' }}
          >
            {snakMessage}
          </Alert>
        </Snackbar>

        <Grid item xs={12} sm={12} md={9} lg={9} style={{ height: '100%' }}>
          <WatchListSearch
            isMobile={isMobile}
            styles={styles}
            setsnaktype={(data) => setsnaktype(data)}
            setFavLoading={(data) => setFavLoading(data)}
            setsnakMessage={(data) => setsnakMessage(data)}
            setsnakOpen={(data) => setsnakOpen(data)}
            setfavTicker={(data) => setfavTicker(data)}
            filteredTickers={filteredTickers}
            setwatchListDeleteData={(data) => setwatchListDeleteData(data)}
            setwatchlistFavDeleteData={(data) =>
              setwatchlistFavDeleteData(data)
            }
            setwatchlistFavDeleteModal={(data) =>
              setwatchlistFavDeleteModal(data)
            }
            zoomPercent={zoomPercent}
            userData={userData}
            favTicker={favTicker}
            setdeleteCheck={setdeleteCheck}
            myFav={myFav}
            setwatchlistDeleteModal={setwatchlistDeleteModal}
            favLoading={favLoading}
            setType={setType}
            deleteCheck={deleteCheck}
            loading={loading}
            accessLevel={accessLevel}
            setmyFav={setmyFav}
            setShowModal={setShowModal}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={3} lg={3} style={{ height: '100%' }}>
          <WatchListRightSide styles={styles} isMobile={isMobile} />
        </Grid>
        {showModal && (
          <ToolTipModal
            showModal={showModal}
            setShowModal={setShowModal}
            isMobile={isMobile}
            type={type}
            clickHandler={() => setShowModal(false)}
            onCloseHandler={() => setShowModal(false)}
          />
        )}
        {watchlistDeleteModal && (
          <WatchListDelete
            handleClickSnak={handleClickSnak}
            userData={userData}
            showModal={watchlistDeleteModal}
            setShowModal={setwatchlistDeleteModal}
            isMobile={isMobile}
            data={watchListDeleteData}
          />
        )}
        {watchlistFavDeleteModal && (
          <WatchListDeleteFavouriteTicker
            favLoading={favLoading}
            userData={userData}
            setwatchlistFavDeleteModal={setwatchlistFavDeleteModal}
            setFavLoading={setFavLoading}
            handleClickSnakFavTicker={handleClickSnakFavTicker}
            showModal={watchlistFavDeleteModal}
            setShowModal={setwatchlistFavDeleteModal}
            isMobile={isMobile}
            data={watchlistFavDeleteData}
          />
        )}
      </Grid>
    </div>
  );
};
export default WatchList;



// WEBPACK FOOTER //
// ./src/Pages/WatchList/index.js